/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsOdd {
  /**
   * Is the number odd
   *
   * @public
   * @function f1.is.odd
   * @example
   *
   * ```ts
   * f1.is.odd(1) => true
   * f1.is.odd(2) => false
   * ```
   */
  (v: number): boolean;
}

/**
 * @see IsOdd
 */
export default (v: number): boolean => {
  return v % 2 === 1;
};
